import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IWorkflow } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAllWorkflowsReturn = RequestsBaseReturn<PaginatedResponse<IWorkflow> | null>;

export type UseGetAllWorkflowsProps = RequestPagination;

type GetAllSwrParams = [string, number, number];

const useGetAllWorkflows = ({
  pageNumber,
  pageSize,
}: UseGetAllWorkflowsProps): UseGetAllWorkflowsReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IWorkflow>, Error, GetAllSwrParams>(
    [SWR_KEYS.getAllWorkflows, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      workflowService.getAll({ pageNumber: _pageNumber, pageSize: _pageSize }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetAllWorkflows;
